import React from 'react';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Button } from '../../../../../CommonComponents/OPL/Button/Button';
import { Modal } from '../../../../../CommonComponents/OPL/Modal/Modal';
import { ModalBody } from '../../../../../CommonComponents/OPL/Modal/ModalBody';
import { ModalCloseButton } from '../../../../../CommonComponents/OPL/Modal/ModalCloseButton';
import { ModalFooter } from '../../../../../CommonComponents/OPL/Modal/ModalFooter';
import { ModalHeader } from '../../../../../CommonComponents/OPL/Modal/ModalHeader';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { IntegrationDTO, StatusDTO } from '../../api/useIntegrationsSettingsQuery';
import { IntegrationInfo } from '../IntegrationInfo/IntegrationInfo';

const website = 'http://ifpartners.com/';

interface Props {
  integration: IntegrationDTO;
  onClose(): void;
}

export const IFP = ({ integration, onClose }: Props) => {
  return (
    <Modal isOpen onRequestClose={onClose} aria={{ labelledby: 'modal-header' }}>
      <ModalHeader as="h2" id="modal-header">
        {integration.Label}
      </ModalHeader>
      <ModalCloseButton onClick={onClose} />

      <ModalBody>
        <IntegrationInfo integration={integration} website={website} />

        {integration.Status === StatusDTO.Success && (
          <Box display="flex" flexDirection="column" css={{ gap: '8px' }} mt="16">
            <Text fontSize="h5">Your IFP connection is active</Text>

            <Text>
              You can now login to Orion Planning from IFP platform by choosing Orion Planning
              integration link.
            </Text>
          </Box>
        )}

        {integration.Status !== StatusDTO.Success && (
          <Box display="flex" flexDirection="column" css={{ gap: '8px' }} mt="16">
            <Text fontSize="h5">Your IFP connection is not active yet.</Text>

            <Text>
              To activate it go to IFP platform and choose Orion Planning integration link.
            </Text>
          </Box>
        )}
      </ModalBody>

      <ModalFooter>
        <Button variant="subtleInactive" onClick={onClose}>
          Cancel
        </Button>

        <Button ml="8" onClick={onClose}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};
